/**
 * useCloudStorage Hook
 * 
 * Hook for consuming the CloudStorageContext
 */

import { useContext } from 'react'
import { CloudStorageContext } from '../contexts/CloudStorageContext'

export const useCloudStorage = () => {
  const context = useContext(CloudStorageContext)
  if (!context) {
    console.warn('useCloudStorage: CloudStorageContext not found, using default values')
    return {
      isConnected: false,
      connectedProvider: null,
      accessToken: null,
      refreshToken: null,
      userInfo: null,
      loading: false,
      authenticateWithGoogleDrive: () => Promise.resolve({ success: false, error: 'Context not available' }),
      disconnectProvider: () => Promise.resolve({ success: false, error: 'Context not available' }),
      testGoogleDriveConnection: () => Promise.resolve({ success: false, error: 'Context not available' }),
      clearCloudTokens: () => {},
      refreshAccessToken: () => Promise.resolve(null),
      resetReconnectionState: () => {},
      stopReconnectionAttempts: () => {},
      uploadFile: () => Promise.reject(new Error('Context not available')),
      downloadFile: () => Promise.reject(new Error('Context not available')),
      deleteFile: () => Promise.reject(new Error('Context not available')),
      listFiles: () => Promise.reject(new Error('Context not available')),
      createFolder: () => Promise.reject(new Error('Context not available')),
      getCloudStorageSettings: () => Promise.reject(new Error('Context not available')),
      updateCloudStorageSettings: () => Promise.reject(new Error('Context not available')),
      getStorageQuota: () => Promise.resolve({ success: false, error: 'Context not available' })
    }
  }
  return context
}
